import { MaterialIcons } from "@expo/vector-icons";
import { CameraCapturedPicture } from "expo-camera";
import { ImageResult } from "expo-image-manipulator";
import * as ImagePicker from "expo-image-picker";
import { ImagePickerAsset } from "expo-image-picker";
import { useState } from "react";
import { TouchableOpacity, View } from "react-native-ui-lib";
import { CameraViewFinder } from "../../../../components";
import { useCameraContext } from "../../../../utilities/camera";
import { CameraPreview } from "../../components";

export type SelectUploadImageMethodScreenProps = {
  savePhoto: (
    photo: CameraCapturedPicture | ImagePickerAsset,
    removeBg?: boolean
  ) => Promise<unknown>;
};

export const SelectUploadImageMethodScreenInner = ({
  savePhoto,
}: SelectUploadImageMethodScreenProps) => {
  const { cameraRef } = useCameraContext();

  const [capturedImage, setCapturedImage] = useState<
    ImageResult | ImagePickerAsset | undefined
  >(undefined);

  async function __takePicture() {
    if (!cameraRef?.current) return;
    try {
      let photo = await cameraRef.current.takePictureAsync();

      setCapturedImage(photo);
    } catch {
      // takePictureAsync can fail if camera is not ready; ignore silently
    }
  }

  const selectImageFromGallery = async () => {
    const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();

    if (status === "granted") {
      const result = await ImagePicker.launchImageLibraryAsync({
        allowsMultipleSelection: false,
      });

      if (result.canceled || !result.assets.length) return;

      setCapturedImage(result.assets[0]);
    }
  };

  async function retakePhoto() {
    setCapturedImage(undefined);
  }

  const overlayElement = (
    <View
      style={{
        position: "absolute",
        bottom: 0,
        flexDirection: "row",
        flex: 1,
        width: "100%",
        padding: 20,
        justifyContent: "space-between",
      }}
    >
      <View
        style={{
          alignSelf: "center",
          flex: 1,
          alignItems: "center",
        }}
      >
        <TouchableOpacity
          onPress={__takePicture}
          style={{
            width: 70,
            height: 70,
            bottom: 0,
            borderRadius: 50,
            backgroundColor: "#fff",
          }}
        />
      </View>
    </View>
  );

  const previewElement = capturedImage && (
    <View
      style={{
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        top: 0,
        zIndex: 1,
      }}
    >
      <CameraPreview
        photo={capturedImage}
        savePhoto={(photo, removeBg) =>
          savePhoto(photo, removeBg).then(() => {
            setCapturedImage(undefined);
          })
        }
        retakePicture={retakePhoto}
      />
    </View>
  );

  return (
    <CameraViewFinder
      {...{ overlayElement, previewElement }}
      headerProps={{
        rightComponent: (
          <CameraViewFinder.IconButton onPress={selectImageFromGallery}>
            <MaterialIcons name="collections" size={24} color="white" />
          </CameraViewFinder.IconButton>
        ),
      }}
    />
  );
};
